import './supTripDateDetails.css';
import TripDateTable from './tripDateTable/TripDateTable';
import { useEffect, useState } from 'react';
import ReactLoading from 'react-loading';
import fetchTripDateTable from './supTripDateFun/fetchTripDateTable';
import moment from 'moment';
import EmptyPage from '../../components/empty-page/emptyPage';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { standardDate } from '../../utils/formatDate';
import { ReactComponent as Download } from '../../assets/icons/trvto_download.svg';
import Dialog from '../../components/dialogModal/dialogModal';
import ConfirmationModal from '../../components/tripStrap/tripStrapFun/cancelBooking';
import { toast } from 'react-toastify';
import errorHandle from '../../utils/errorHandle';
import AddBooking from './addBooking/AddBooking';
import { stopReviewFun, supOrgTripCancelFun } from '../../api/supportAdmin';
import { sendMessage } from './supTripDateFun/sendMessage';

//pagination not required as we are populating data from bookingId array.
//And data wont reach more than 200

export default function SupTripDateDetails() {
    const location = useLocation();
    const navigate = useNavigate();
    const { orgId, mode } = useParams();
    const [tripDateDetails, setTripDateDetails] = useState({
        bookingId: [],
        contentId: {}
    });
    const [addBo, setAddBo] = useState(false);
    const [loading, setLoading] = useState(false);
    const [load, setLoad] = useState(false);
    const [modal, setModal] = useState(false);
    const [reviewModal, setReviewModal] = useState(false);
    const [cancelTripModal, setCancelTripModal] = useState(false);
    const [rowData, setRowData] = useState({});
    const [messageType, setMessageType] = useState([]);
    const [messageData, setMessageData] = useState({
        msgType: 'whatsApp',
        whatsApp: '',
        message: ''
    });
    const refresh = () => {
        setLoad(!load);
    };

    const dummyMessageType = [
        { value: 'whatsApp', name: 'WhatsApp' },
        { value: 'rate', name: 'Rate' },
        { value: 'custom', name: 'Custom' }
    ];

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        fetchTripDateTable(setTripDateDetails, setLoading);
        setMessageType(dummyMessageType);
        //eslint-disable-next-line
    }, [load]);

    const now = moment();
    const start = moment(tripDateDetails?.startDate);
    const end = moment(tripDateDetails?.endDate);

    const tripStatus = now.isBefore(start)
        ? 'Upcoming'
        : now.isBetween(start, end, undefined, '[]')
          ? 'In Progress'
          : 'Completed';

    async function handleTripCancel(e) {
        e.stopPropagation();
        setLoading(true);

        try {
            const newDate = await supOrgTripCancelFun({ packDateId: tripDateDetails._id });
            if (newDate.status === 200) {
                toast.success('Successfully cancelled trip');
                setCancelTripModal(false);
                navigate(`/support/${mode}/dashboard/${orgId}`);
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            errorHandle(error);
        }
    }

    async function handleStopReview(e) {
        e.stopPropagation();
        setLoading(true);

        try {
            const review = await stopReviewFun({ packDateId: tripDateDetails._id });
            if (review.status === 200) {
                toast.success('Successfully stopped review');
                setReviewModal(false);
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            errorHandle(error);
        }
    }
    console.log(tripDateDetails);
    return (
        <div>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            {/* <button className='backBtn hideOnPrint' onClick={() => navigate(-1)}>
                <img src={BackIcon} alt='back' />
                {`Back to Trip Details`}
            </button> */}
            {Object.keys(tripDateDetails.contentId).length !== 0 ? (
                <div className='orgTripDateUpDiv'>
                    <div className='orgTripDateHeadingDiv'>
                        <h1 className='orgTripDateName'>{tripDateDetails?.contentId?.title ?? 'N/A'}</h1>
                        <div>
                            <div>
                                <span className='orgTripDateSubDetails'>
                                    {tripDateDetails?.contentId?.days + 'D/' + tripDateDetails?.contentId?.nights + 'N'}
                                </span>

                                <span className='orgTripDateDot'></span>
                                <span className='orgTripDateSubDetails'>
                                    {standardDate(tripDateDetails?.startDate?.split('T')[0]) ?? 'N/A'}
                                </span>
                                <span className='orgTripDateDot'></span>
                                <span className='orgTripDateSubDetails'>
                                    {tripDateDetails?.contentId?.quickView?.startTime ?? 'N/A'}
                                </span>
                                <span className='orgTripDateDot'></span>
                                <span className='orgTripDateSubDetails'>
                                    {tripDateDetails?.contentId?.quickView?.baseCities ?? 'N/A'}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className='cardLayout'>
                        <div className='orgTripDateOverview'>
                            {tripDateDetails?.status !== 'cancelled' &&
                                tripDateDetails?.bookingId?.some((item) => item?.tripStatus !== 'Completed') && (
                                    <button
                                        className='orgPackCreateBtn blueBtn'
                                        onClick={() => {
                                            setModal(true);
                                            setRowData(tripDateDetails?._id);
                                        }}
                                    >
                                        Send Message
                                    </button>
                                )}
                            <div className='orgTripDateInfo'>
                                <span className='orgTripDateSpan'>Booked</span>
                                <span className='orgTripDateSpan'>{tripDateDetails?.bookedSlots ?? '0'}</span>
                            </div>
                            <div className='orgTripDateInfo'>
                                <span className='orgTripDateSpan'>Total Slots</span>
                                <span className='orgTripDateSpan'>{tripDateDetails?.totalSlots ?? '0'}</span>
                            </div>
                            <div className='orgTripDateInfo'>
                                <span className='orgTripDateSpan'>Status</span>
                                <span className='orgTripDateSpan'>
                                    {tripDateDetails?.status === 'cancelled' ? 'Cancalled' : tripStatus}
                                </span>
                            </div>
                            {tripStatus === 'Upcoming' ? (
                                <>
                                    {tripDateDetails?.status !== 'cancelled' && (
                                        <button
                                            className='cancelbtn'
                                            onClick={() => {
                                                setCancelTripModal(true);
                                            }}
                                        >
                                            Cancel Trip
                                        </button>
                                    )}
                                    {tripDateDetails?.status !== 'cancelled' && (
                                        <div className='orgTripBtnDiv'>
                                            {location.state !== 'completed' && (
                                                <button className='orgTipBtnDow blueBtn' onClick={() => setAddBo(true)}>
                                                    Add Booking
                                                </button>
                                            )}
                                        </div>
                                    )}
                                </>
                            ) : (
                                tripDateDetails?.status !== 'cancelled' &&
                                tripDateDetails?.bookingId?.some((item) => item?.tripStatus !== 'Completed') && (
                                    <button
                                        className='cancelbtn'
                                        onClick={() => {
                                            setReviewModal(true);
                                        }}
                                    >
                                        Stop review
                                    </button>
                                )
                            )}
                        </div>
                    </div>
                    {/* <div className="orgTripBtnDiv">
            <button className="orgTipBtnDow">Download</button>
          </div> */}
                </div>
            ) : (
                <EmptyPage />
            )}
            <button className='floatingPrintButton hideOnPrint' onClick={() => window.print()}>
                <Download /> Download
            </button>
            {tripDateDetails.bookingId.length !== 0 ? (
                <TripDateTable
                    bookingData={tripDateDetails.bookingId}
                    contentData={tripDateDetails.contentId}
                    tripStatus={tripStatus}
                    setLoading={setLoading}
                    refresh={refresh}
                    tripDateDetails={tripDateDetails}
                />
            ) : (
                <EmptyPage />
            )}
            {Object.keys(tripDateDetails.contentId).length !== 0 && addBo && (
                <AddBooking packData={tripDateDetails} setAddBo={setAddBo} setLoading={setLoading} refresh={refresh} />
            )}
            {modal && (
                <Dialog openModal={modal} heading={'Send Message'} loading={loading}>
                    <div className='dialogContent'>
                        <select
                            name='date'
                            id='date'
                            className='select w-full'
                            value={'whatsApp'}
                            onChange={(e) =>
                                setMessageData({
                                    ...messageData,
                                    msgType: e.target.value
                                })
                            }
                            disabled
                        >
                            <option value=''>Select Message Type</option>
                            {messageType.map((type) => (
                                <option value={type.value} key={type.value}>
                                    {type.name}
                                </option>
                            ))}
                        </select>
                        {messageData.msgType === 'whatsApp' && (
                            <input
                                placeholder='Whatsapp group link'
                                name='whatsapp'
                                onChange={(e) =>
                                    setMessageData({
                                        ...messageData,
                                        whatsApp: e.target.value
                                    })
                                }
                                value={messageData.whatsApp}
                                className='whatsAppLink'
                            />
                        )}
                        {/* {messageData.msgType !== 'rate' &&
                                            messageData.msgType !== 'whatsApp' && (
                                                <>
                                                    <textarea
                                                        className="messageArea"
                                                        value={messageData.message}
                                                        onChange={(e) =>
                                                            setMessageData({
                                                                ...messageData,
                                                                message: e.target.value
                                                            })
                                                        }
                                                    />
                                                    <CharCount
                                                        string={
                                                            messageData.message
                                                                ? messageData.message
                                                                : ''
                                                        }
                                                        min={10}
                                                        limit={50}
                                                    />
                                                </>
                                            )} */}
                        <p className='note'>
                            Note:{' '}
                            <span>The message will be sent to all the customers in this particular trip date</span>
                        </p>
                        <div className='alignCenter'>
                            <button className='dialogActBtn cancel' onClick={() => setModal(false)}>
                                Cancel
                            </button>
                            <button
                                className='dialogActBtn submit'
                                disabled={!messageData.msgType}
                                onClick={() =>
                                    sendMessage(
                                        {
                                            ...messageData,
                                            msgType: 'whatsApp',
                                            packDateId: rowData
                                        },
                                        setLoading,
                                        setModal
                                    )
                                }
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                </Dialog>
            )}
            {cancelTripModal && (
                <ConfirmationModal
                    setShowModal={setCancelTripModal}
                    handleConfirm={(e) => handleTripCancel(e)}
                    message='Do you want to cancel the trip?'
                />
            )}{' '}
            {reviewModal && (
                <ConfirmationModal
                    setShowModal={setReviewModal}
                    handleConfirm={(e) => handleStopReview(e)}
                    message={'Do you want to stop the review?'}
                />
            )}
        </div>
    );
}
